<script>
  import { getSeriesIndex, getSeriesWorks } from "./albums";
  import { link } from "./router";

  export let series = null;
  export let openGallery;

  let works;
  $: works = series ? getSeriesWorks(series) : [];
</script>

<div class="page">
  {#if !series}
    <h1 class="page-title">Work</h1>
    <div class="series-grid">
      {#each getSeriesIndex() as s (s.name)}
        <a class="series-card" href="/work/{s.name}" on:click={link}>
          <img src="/images/{s.cover}/1_thumb.jpeg" alt={s.name} />
          <p>{s.name}</p>
        </a>
      {/each}
    </div>
  {:else}
    <div class="crumb"><a href="/work" on:click={link}>Work</a></div>
    <h1 class="page-title">{series}</h1>
    <div class="works">
      {#each works as album (album.album)}
        <div
          on:click={() => openGallery(album.album, works.map((w) => w.album))}
          class="album"
        >
          <img
            class="work-image"
            src="/images/{album.album}/1_thumb.jpeg"
            alt={album.name}
          />
          <p>
            <i>{album.name}</i>, {album.year}<br />
            {album.materials}{#if album.size}, {album.size}{/if}
          </p>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem 2rem 10rem 2rem;
  }

  .page-title {
    font-family: "Cormorant Garamond", serif;
    font-weight: 400;
    font-size: 2.6rem;
    line-height: 1;
    color: #1a1a1a;
    margin: 1rem 0 0.5rem 0;
  }

  .crumb {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.18em;
  }
  .crumb a {
    color: #999;
    text-decoration: none;
  }
  .crumb a:hover {
    color: #111;
  }

  .series-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3rem 2.5rem;
    padding-top: 3rem;
    max-width: 72rem;
  }
  .series-card {
    display: flex;
    flex-direction: column;
    text-decoration: none;
  }
  .series-card img {
    width: min(300px, 80vw);
    border: 1px solid var(--hairline);
    box-sizing: border-box;
  }
  .series-card p {
    font-family: "Cormorant Garamond", serif;
    font-size: 1.4rem;
    color: #333;
    margin: 0;
    padding: 0.7rem 0 0 0;
    text-align: center;
  }
  .series-card:hover p {
    color: var(--accent);
  }

  .works {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 4rem 3rem;
    padding-top: 3.5rem;
  }
  .album {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    max-width: min(420px, 86vw);
  }
  .album p {
    font-size: 0.8rem;
    color: #777;
    margin: 0;
    padding: 0.8rem 0 0 0;
    text-align: center;
    line-height: 1.5;
  }
  .work-image {
    width: min(420px, 86vw);
    border: 1px solid var(--hairline);
    box-sizing: border-box;
  }


  @media (max-width: 800px) {
    .page {
      padding: 1.5rem 1rem 6rem 1rem;
    }
  }
</style>
